import React from "react"
import "./app.css"

const App = ({ children }) => {
  return <div className="app">{children}</div>
}

export default App
